import React, {useEffect, useRef, useState} from "react";
import {useSelector} from "react-redux";
import NoData from "../../../components/NoDataFound/NoData";
import {getCertificateListRequest} from "../../../utils/apis/account";
import "./style.scss";
import LoaderOverlay from "../../../reusableComponents/Loader";
import {Skeleton} from "antd";

const AllCertificates = () => {
  const [openModal, setOpenModal] = useState(false);
  const idToken = useSelector((state) => state.auth.idToken);
  const [certificateList, setCertificateList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
    const selectedBrand = useSelector((state) => state.brand.selectedBrand);
  
  const fetchCertificates = async () => {
    setIsLoading(true);
    const response = await getCertificateListRequest(idToken,selectedBrand);
    setCertificateList(response);
    setIsLoading(false);
  };
  useEffect(() => {
    fetchCertificates();
  }, [idToken]);

  function splitTitle(title) {
    const parts = title.split(" - ");
    return {
      id: parts[0]?.trim() || "",
      name: parts[1]?.trim() || "",
      type: parts[2]?.trim() || "",
    };
  }
  useEffect(() => {
    if (isLoading) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [isLoading]);

  const [loadedImages, setLoadedImages] = useState({});

  const handleImageLoad = (idx) => {
    setLoadedImages((prev) => ({...prev, [idx]: true}));
  };

  return (
    <>
      {isLoading && <LoaderOverlay />}
      {certificateList.length <= 0 && <NoData msg={"No certificates found"} />}
      <div className="main_certificates">
        {certificateList?.map((item, idx) => (
          <div
            className="certificate-cards"
            key={idx}
          >
            <div
              className="inner-card"
              onClick={() => setOpenModal(true)}
            >
              <div className="certificate-img">
                {!loadedImages[idx] && (
                  <Skeleton.Image
                    active={true}
                    style={{
                      width: "100%",
                      height: "200px",
                    }}
                  />
                )}
                <img
                  src={item.file}
                  alt="certificate card"
                  className="card-img"
                  style={{display: loadedImages[idx] ? "block" : "none"}} // Hide until loaded
                  onLoad={() => handleImageLoad(idx)}
                  onError={() => handleImageLoad(idx)} // Handle broken image cases
                />
              </div>
              <div className="cert-card-info">
                <div>
                  <h2 className="card-title">{splitTitle(item.title).name}</h2>
                  <h2 className="card-title">{splitTitle(item.title).type}</h2>
                </div>
                <div>
                  <h2 className="card-title">{splitTitle(item.title).id}</h2>
                  <h2 className="date">{item.created_at}</h2>
                </div>
              </div>
              <div
                className="card-download"
                onClick={(e) => e.stopPropagation()}
                style={{cursor: "pointer"}}
              >
                <a
                  href={item.file}
                  target="_blank"
                >
                  <button>Download </button>
                </a>
              </div>
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default AllCertificates;
